import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "motion/react";
import "./CaseStudyTile.scss";

const CaseStudyTile = ({ study, index }) => {
  const navigate = useNavigate();

  return (
    <motion.div
      className="cs-tile"
      style={{
        backgroundColor: study.color,
        color: study.fontColor,
      }}
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        duration: 0.6,
        delay: index * 0.1,
        ease: [0.22, 1, 0.36, 1],
      }}
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      onClick={() => navigate(`/work/${study.slug}`)}
    >
      {study.thumbnail && (
        <div className="cs-tile__image">
          <img src={study.thumbnail} alt={study.title} />
        </div>
      )}
      <div className="cs-tile__content">
        <h2>{study.title}</h2>
        {study.description && <p>{study.description}</p>}
        {study.tags?.length > 0 && (
          <div className="cs-tile__tags">
            {study.tags.map((tag) => (
              <span key={tag} className="cs-tile__tag">
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </motion.div>
  );
};

export { CaseStudyTile };
